
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [291708, 554670, 5069, 647990, 65048, 245339, 102657, 91345, 517259, 341505] }, uniqueName: "canvas-lms" };
__webpack_require__.I = __webpack_require__.I || function() { throw new Error("should have __webpack_require__.I") }
